var map = {
	"./1.jpg": 2617,
	"./10.jpg": 4677,
	"./2.jpg": 1698,
	"./3.jpg": 2430,
	"./4.jpg": 9769,
	"./5.jpg": 4736,
	"./6.jpg": 4670,
	"./7.jpg": 1817,
	"./8.jpg": 9913,
	"./9.jpg": 4761
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8786;